import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderPaymentComponent } from './components/header-payment/header-payment.component';
import { HeaderTimePaymentComponent } from './components/header-time-payment/header-time-payment.component';
import { LoaderPageComponent } from './components/loader-page/loader-page.component';
import { ContinueFormPageComponent } from './components/continue-form-page/continue-form-page.component';

@NgModule({
  declarations: [
    HeaderPaymentComponent,
    HeaderTimePaymentComponent,
    LoaderPageComponent,
    ContinueFormPageComponent,
  ],
  imports: [CommonModule],
  exports: [
    HeaderPaymentComponent,
    HeaderTimePaymentComponent,
    LoaderPageComponent,
    ContinueFormPageComponent,
  ],
})
export class SharedModule {}
